<span class="uikit-icon">
  <svg [attr.class]="'insight-' + icon">
    <use [attr.xlink:href]="symbolPath + '#insight-' + icon" [attr.href]="symbolPath + '#insight-' + icon"></use>
  </svg>
</span>
